module.exports = __webpack_public_path__ + "static/media/country_ml.ae865ab1.webp";